import { render, staticRenderFns } from "./orderInformation.vue?vue&type=template&id=5b9b2fda&scoped=true&"
import script from "./orderInformation.vue?vue&type=script&lang=js&"
export * from "./orderInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9b2fda",
  null
  
)

export default component.exports